import { render, staticRenderFns } from "./LayoutConfigurationTitle.vue?vue&type=template&id=2c18a23e&scoped=true&"
import script from "./LayoutConfigurationTitle.vue?vue&type=script&lang=js&"
export * from "./LayoutConfigurationTitle.vue?vue&type=script&lang=js&"
import style0 from "./LayoutConfigurationTitle.vue?vue&type=style&index=0&id=2c18a23e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18a23e",
  null
  
)

export default component.exports